import { Component } from '@angular/core';
import { InfiniteScroll, NavController, NavParams } from 'ionic-angular';
import { RanglistListModel, RanglistSearchModel, ResultProvider } from '../../../providers/result/result';

/**
 * Generated class for the ResoultRanglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-ranglist',
  templateUrl: 'result-ranglist.html',
})
export class ResultRanglistPage {

  search: RanglistSearchModel;
  list: RanglistListModel[] = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public resultService: ResultProvider) {
    console.log(navParams.data);
    this.search = navParams.data.data.search;
    this.list = navParams.data.data.list;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResoultRanglistPage');
  }

  loadNextPage(event: InfiniteScroll) {
    this.resultService.getRangList(this.search).then((data: RanglistListModel[]) => {
      this.list = data;
      event.complete();
    });
  }

}



// WEBPACK FOOTER //
// /src/pages/results/result-ranglist/result-ranglist.ts